import React from 'react'
import tw from 'twin.macro'
import styled from 'styled-components'
import useHttpLocations from 'hooks/useHttpLocations'
import Logo from './Logo'

const StyledListLogo = styled(Logo)<{ size: string }>`
  ${tw`bg-white bg-opacity-90 shadow-sm rounded-full p-2`}
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`

export default function ListLogo({
  logoURI,
  style,
  size = '24px',
  alt,
}: {
  logoURI: string
  size?: string
  style?: React.CSSProperties
  alt?: string
}) {
  const srcs: string[] = useHttpLocations(logoURI)

  return <StyledListLogo alt={alt} size={size} srcs={srcs} style={style} />
}
